import { useContext } from 'react';
import {
  SnackbarContext,
  SnackbarContextType,
} from 'src/context/SnackbarContext';
import { ErrorHandler } from 'src/utils/errorHandler';

export const useSnackbarContext = (): SnackbarContextType => {
  const context = useContext(SnackbarContext);
  if (context === undefined) {
    const error = new Error(
      'useSnackbarContext must be used within a SnackbarProviderWrapper'
    );
    ErrorHandler.handleError(error, { rethrow: true });
    throw error; // This will never be reached due to rethrow: true, but TypeScript needs it
  }
  return context;
};
